/*
 * curated-first-from-source.js
 * Pins the product from an ad to the first slot of a collection grid.
 *
 * URL params (on any /collections/... page):
 *   first    Product handle OR a full (encoded) product URL to pin at slot #1. (required)
 *   variant  Variant ID to pre-select and show its image on the pinned card. (optional)
 *   limit    Max number of products to show in the grid. (optional)
 *
 * Fails silently and never breaks the page.
 */
(function () {
  'use strict';

  try {
    var params = new URLSearchParams(window.location.search);
    var firstParam = params.get('first');
    if (!firstParam) return;

    var handle = extractHandle(firstParam);
    if (!handle) return;

    var variantId = params.get('variant') || extractVariant(firstParam);
    var limit = parseInt(params.get('limit'), 10);

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    pinProduct(grid, handle, variantId, limit);
  } catch (e) {
    if (window.console && console.warn) console.warn('[curated-first]', e);
  }

  // ---- helpers ----------------------------------------------------------

  function decode(value) {
    try { return decodeURIComponent(value); } catch (e) { return value; }
  }

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function extractHandle(value) {
    var v = decode(value);
    var m = v.match(/\/products\/([a-z0-9\-_]+)/i);
    if (m) return m[1];
    return v.split('?')[0].split('#')[0].split('/').pop();
  }

  function extractVariant(value) {
    var m = decode(value).match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function handleRe(handle) {
    return new RegExp('/products/' + escapeRe(handle) + '(?:[/?#]|$)', 'i');
  }

  function findCardLi(grid, handle) {
    var re = handleRe(handle);
    var lis = grid.querySelectorAll('li.grid__item');
    for (var i = 0; i < lis.length; i++) {
      var a = lis[i].querySelector('a[href*="/products/"]');
      if (a && re.test(a.getAttribute('href') || '')) return lis[i];
    }
    return null;
  }

  function detectView(grid) {
    var card = grid.querySelector('.card');
    if (card) {
      var m = (card.getAttribute('style') || '').match(/--ratio-percent:\s*([\d.]+)%/);
      if (m) {
        var r = parseFloat(m[1]);
        if (r > 115) return 'card-portrait';
        if (r <= 105) return 'card-square';
      }
    }
    return 'card-portrait';
  }

  function pinProduct(grid, handle, variantId, limit) {
    var existing = findCardLi(grid, handle);
    if (existing) {
      grid.insertBefore(existing, grid.firstElementChild);
      afterPin(grid, existing, handle, variantId, limit);
      return;
    }
    fetchCard(handle, detectView(grid), function (li) {
      if (li) {
        grid.insertBefore(li, grid.firstElementChild);
        afterPin(grid, li, handle, variantId, limit);
      } else {
        applyLimit(grid, limit);
      }
    });
  }

  function afterPin(grid, li, handle, variantId, limit) {
    dedupe(grid, handle, li);
    if (variantId) applyVariant(li, handle, variantId);
    applyLimit(grid, limit);
  }

  function dedupe(grid, handle, keep) {
    var re = handleRe(handle);
    var lis = grid.querySelectorAll('li.grid__item');
    for (var i = 0; i < lis.length; i++) {
      if (lis[i] === keep) continue;
      var a = lis[i].querySelector('a[href*="/products/"]');
      if (a && re.test(a.getAttribute('href') || '')) {
        lis[i].parentNode.removeChild(lis[i]);
      }
    }
  }

  function applyLimit(grid, limit) {
    if (!limit || isNaN(limit) || limit < 1) return;
    var lis = grid.querySelectorAll('li.grid__item');
    for (var i = lis.length - 1; i >= limit; i--) {
      lis[i].parentNode.removeChild(lis[i]);
    }
  }

  function fetchCard(handle, view, cb) {
    fetch('/products/' + encodeURIComponent(handle) + '?view=' + view, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return cb(null);
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var card = tmp.querySelector('.card-wrapper') || tmp.firstElementChild;
        if (!card) return cb(null);
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.appendChild(card);
        cb(li);
      })
      .catch(function () { cb(null); });
  }

  function applyVariant(li, handle, variantId) {
    var links = li.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href) links[i].setAttribute('href', setParam(href, 'variant', variantId));
    }
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        var match = null;
        for (var i = 0; i < data.variants.length; i++) {
          if (String(data.variants[i].id) === String(variantId)) { match = data.variants[i]; break; }
        }
        var src = match && match.featured_image && match.featured_image.src;
        if (!src) return;
        var img = li.querySelector('.card__media img') || li.querySelector('img');
        if (!img) return;
        img.setAttribute('src', withWidth(src, 533));
        img.removeAttribute('srcset');
      })
      .catch(function () {});
  }

  function setParam(url, key, val) {
    var re = new RegExp('([?&])' + key + '=[^&#]*');
    if (re.test(url)) return url.replace(re, '$1' + key + '=' + val);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + key + '=' + val;
  }

  function withWidth(src, w) {
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return src; }
  }
})();
